function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  "data-name": "\\u0421\\u043B\\u043E\\u0439 2",
  id: "\\u0421\\u043B\\u043E\\u0439_2",
  stroke: "null"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 1",
  id: "Layer_1",
  stroke: "null"
}, /*#__PURE__*/React.createElement("path", {
  id: "svg_1",
  fill: "#4a90e2",
  d: "m15.19031,7.35705l-3.2146,9.69738l-1.93641,0l-2.37268,-7.17162l-2.44157,7.17162l-1.92111,0l-3.2146,-9.69738l1.86753,0l2.41095,7.37062l2.51045,-7.37062l1.63026,0l2.44922,7.40889l2.51045,-7.40889l1.72211,0z",
  stroke: "null"
}), /*#__PURE__*/React.createElement("path", {
  id: "svg_2",
  fill: "#4a90e2",
  d: "m21.03782,17.16923a5.61024,5.61024 0 0 1 -2.66353,-0.63527a4.89844,4.89844 0 0 1 -1.85222,-1.79099a4.95201,4.95201 0 0 1 -0.66588,-2.55637a4.82955,4.82955 0 0 1 2.53341,-4.31675a5.44951,5.44951 0 0 1 2.66353,-0.65057a5.58728,5.58728 0 0 1 2.17368,0.41331a4.43921,4.43921 0 0 1 1.66088,1.2093l-1.16338,1.09449a3.40595,3.40595 0 0 0 -2.59464,-1.14042a3.64321,3.64321 0 0 0 -1.78334,0.44392a3.12275,3.12275 0 0 0 -1.23226,1.2093a3.43656,3.43656 0 0 0 -0.42096,1.76038a3.42891,3.42891 0 0 0 0.44392,1.75272a3.20695,3.20695 0 0 0 1.23226,1.22461a3.71975,3.71975 0 0 0 1.78334,0.42861a3.39064,3.39064 0 0 0 2.59464,-1.14807l1.16338,1.10215a4.37033,4.37033 0 0 1 -1.67618,1.2093a5.55667,5.55667 0 0 1 -2.19664,0.39034l-0.00001,0.00001z",
  stroke: "null"
}))));

var SvgWc = function SvgWc(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 25",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWc, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/wc.3f7b564d.svg";
export { ForwardRef as ReactComponent };